import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Link,
  IconButton,
  Container,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
  Tooltip,
} from "@chakra-ui/react";
import { FaFacebookF } from "react-icons/fa";
import { FiLogOut, FiLock } from "react-icons/fi";
import AdminLoginModal from './AdminLoginModal';
import { logoutAdmin, isAdminLoggedIn } from '../../services/adminAuth';

export default function SmallWithSocial() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isAdmin, setIsAdmin] = useState(false);

  // Check admin status when component mounts
  useEffect(() => {
    const checkAdminStatus = () => {
      setIsAdmin(isAdminLoggedIn());
    };
    
    checkAdminStatus();
    
    // Listen for admin status changes
    window.addEventListener('adminStatusChanged', checkAdminStatus);
    
    return () => {
      window.removeEventListener('adminStatusChanged', checkAdminStatus);
    };
  }, []);

  // Handle admin logout
  const handleLogout = () => {
    logoutAdmin();
    setIsAdmin(false);
  };

  return (
    <Box
      bg={useColorModeValue("gray.50", "gray.900")}
      color={useColorModeValue("gray.700", "gray.200")}
    >
      <Container
        as={Stack}
        maxW={"6xl"}
        py={4}
        direction={{ base: "column", md: "row" }}
        spacing={4}
        justify={{ base: "center", md: "space-between" }}
        align={{ base: "center", md: "center" }}
      >
        <Text fontSize={{ base: 'xs', md: 'md' }} textAlign="center">
          © 2025 Hidatsa Áabaci. All rights reserved
        </Text>
        <Stack direction={"row"} spacing={{ base: 2, md: 6 }}>
          <Link
            href="https://facebook.com/miaagarishda.hidatsa.3?refid=13&__tn__=%2Cg" 
            isExternal
          >
            <IconButton 
              icon={<FaFacebookF />}
              isRound='true'
              size={{ base: 'sm', md: 'md' }}
            />
          </Link>
          
          {isAdmin ? (
            // Show logout button when admin is logged in
            <>
              {/* Icon only on mobile, full button on desktop */}
              <Tooltip label="Logout Admin" display={{ base: 'block', md: 'none' }}>
                <IconButton
                  display={{ base: 'flex', md: 'none' }}
                  icon={<FiLogOut />}
                  colorScheme="red"
                  onClick={handleLogout}
                  isRound
                  size="sm"
                  aria-label="Logout Admin"
                />
              </Tooltip>
              <Button
                display={{ base: 'none', md: 'flex' }}
                fontWeight={600}
                colorScheme="red"
                onClick={handleLogout}
                leftIcon={<FiLogOut />}
                variant="solid"
                _hover={{
                  bg: "red.400"
                }}
              >
                Logout Admin
              </Button>
            </>
          ) : (
            // Show admin login button when not logged in
            <>
              {/* Icon only on mobile, full button on desktop */}
              <Tooltip label="Admin Login" display={{ base: 'block', md: 'none' }}>
                <IconButton
                  display={{ base: 'flex', md: 'none' }}
                  icon={<FiLock />}
                  colorScheme="messenger"
                  onClick={onOpen}
                  isRound
                  size="sm"
                  variant="outline"
                  aria-label="Admin Login"
                />
              </Tooltip>
              <Button
                display={{ base: 'none', md: 'flex' }}
                fontWeight={600}
                colorScheme="messenger"
                onClick={onOpen}
                variant="outline"
                _hover={{
                  bg: "blue.300"
                }}
              >
                Admin
              </Button>
            </>
          )}
        </Stack>
      </Container>
      <AdminLoginModal isOpen={isOpen} onClose={onClose} setIsAdmin={setIsAdmin} />
    </Box>
  );
}